export default __webpack_public_path__ + "static/media/icon_mobile.70f066f2.png";